import { SpaceBetween } from '@risk-smart/themed-cloudscape-components';
import type { RiskScoringSettingsLang } from '@risksmart-app/atomic-ui';
import { Box, RiskScoringSettings } from '@risksmart-app/atomic-ui';
import Button from '@risksmart-app/components/src/button';
import { useTranslation } from 'react-i18next';
import ActionsButton from 'src/components/actions-button';
import { PageLayout } from 'src/layouts';

import { useRiskScoringSettingsStore } from './useRiskScoringSettingsStore';

const Page = () => {
  const { t } = useTranslation(['common'], {
    keyPrefix: 'riskScoringSettings',
  });
  const { state, actions, isLoading } = useRiskScoringSettingsStore();

  const lang = {
    alert: {
      title: t('alert.title'),
      subtitle: {
        impactLikelihood: t('alert.subtitle.impactLikelihood'),
        multiImpact: t('alert.subtitle.multiImpact'),
      },
      description: {
        default: t('alert.description.default'),
        pending: t('alert.description.pending'),
      },
    },
    page: {
      header: t('page.header'),
      description: t('page.description'),
    },
    impactLikelihoodCard: {
      title: t('impactLikelihoodCard.title'),
      description: t('impactLikelihoodCard.description'),
      selectedAlertText: t('impactLikelihoodCard.selectedAlertText'),
      selectedBadgeText: t('impactLikelihoodCard.selectedBadgeText'),
      setupBadgeText: t('impactLikelihoodCard.setupBadgeText'),
    },
    multiImpactCard: {
      title: t('multiImpactCard.title'),
      description: t('multiImpactCard.description'),
      selectedAlertText: t('multiImpactCard.selectedAlertText'),
      selectedBadgeText: t('multiImpactCard.selectedBadgeText'),
      setupBadgeText: t('multiImpactCard.setupBadgeText'),
      unselectedAlertText: t('multiImpactCard.unselectedAlertText'),
      unselectedBadgeText: t('multiImpactCard.unselectedBadgeText'),
    },
    likelihoodLevels: {
      title: t('likelihoodLevels.title'),
      description: t('likelihoodLevels.description'),
      addButton: t('likelihoodLevels.addButton'),
    },
    impactLevels: {
      title: t('impactLevels.title'),
      description: t('impactLevels.description'),
      addButton: t('impactLevels.addButton'),
    },
    matrix: {
      title: t('matrix.title'),
      description: t('matrix.description'),
      alert: {
        description: t('matrix.alert.description'),
      },
    },
    invertMatrixToggle: {
      title: t('invertMatrixToggle.title'),
      checked: t('invertMatrixToggle.checked'),
      unchecked: t('invertMatrixToggle.unchecked'),
    },
    impactCategories: {
      title: t('impactCategories.title'),
      description: t('impactCategories.description'),
      addButton: t('impactCategories.addButton'),
    },
  } satisfies RiskScoringSettingsLang;

  if (isLoading) {
    return <PageLayout title={t('page.title')} />;
  }

  return (
    <PageLayout
      title={t('page.title')}
      actions={
        <SpaceBetween direction={'horizontal'} size={'xs'}>
          <Button
            variant={'primary'}
            formAction={'none'}
            onClick={() => {
              /* empty */
            }}
          >
            {'Save'}
          </Button>
          <Button
            variant={'normal'}
            formAction={'none'}
            onClick={() => {
              /* empty */
            }}
          >
            {'Reset'}
          </Button>
          <ActionsButton
            key={'actions'}
            buttonText={'Actions'}
            items={[
              {
                id: 'preview',
                text: 'Show Preview',
                onItemClick: () => {
                  /* empty */
                },
              },
              {
                id: 'history',
                text: 'Version History',
                onItemClick: () => {
                  /* empty */
                },
              },
            ]}
          />
        </SpaceBetween>
      }
    >
      <Box className={'mx-auto'}>
        <RiskScoringSettings lang={lang} state={state} actions={actions} />
      </Box>
    </PageLayout>
  );
};

export default Page;
